import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const EngagementFeedItem = ({ item }) => {
  const [showReply, setShowReply] = useState(false);
  const [replyText, setReplyText] = useState(item?.suggestedResponse || '');

  const getTypeIcon = (type) => {
    if (type === 'like') return 'Heart';
    if (type === 'comment') return 'MessageCircle';
    if (type === 'share') return 'Share2';
    if (type === 'mention') return 'AtSign';
    return 'Bell';
  };

  const getTypeColor = (type) => {
    if (type === 'like') return 'var(--color-error)';
    if (type === 'comment') return 'var(--color-primary)';
    if (type === 'share') return 'var(--color-success)';
    if (type === 'mention') return 'var(--color-accent)';
    return 'var(--color-muted-foreground)';
  };

  const getVelocityBadge = (velocity) => {
    if (velocity === 'high') {
      return <span className="text-xs px-2 py-0.5 rounded-full bg-error/20 text-error">High Activity</span>;
    }
    if (velocity === 'medium') {
      return <span className="text-xs px-2 py-0.5 rounded-full bg-accent/20 text-accent">Trending</span>;
    }
    return null;
  };

  const getPlatformIcon = (platform) => {
    if (platform === 'linkedin') return 'Linkedin';
    if (platform === 'twitter') return 'Twitter';
    return 'Share2';
  };

  const getPlatformColor = (platform) => {
    if (platform === 'linkedin') return '#0A66C2';
    if (platform === 'twitter') return '#1DA1F2';
    return 'var(--color-primary)';
  };

  const handleSendReply = () => {
    setShowReply(false);
    alert('Reply sent successfully!');
  };

  return (
    <div className="bg-background rounded-lg p-4 border border-border hover:border-primary/30 transition-all">
      {/* Header */}
      <div className="flex items-start gap-3 mb-3">
        {/* User Avatar */}
        <div className="relative flex-shrink-0">
          <Image
            src={item?.user?.avatar}
            alt={item?.user?.avatarAlt}
            className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
          />
          <div
            className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center border-2 border-background"
            style={{ backgroundColor: `${getTypeColor(item?.type)}` }}
          >
            <Icon name={getTypeIcon(item?.type)} size={10} color="white" />
          </div>
        </div>

        {/* User Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <div>
              <h4 className="text-sm font-semibold text-foreground">{item?.user?.name}</h4>
              <p className="text-xs text-muted-foreground">{item?.user?.title}</p>
            </div>
            <div className="flex items-center gap-2">
              {getVelocityBadge(item?.velocity)}
              <Icon
                name={getPlatformIcon(item?.platform)}
                size={16}
                color={getPlatformColor(item?.platform)}
              />
            </div>
          </div>
          <span className="text-xs text-muted-foreground">{item?.timestamp}</span>
        </div>
      </div>

      {/* Content */}
      {item?.content && (
        <div className="mb-3 pl-0 md:pl-15">
          <p className="text-sm text-foreground">{item?.content}</p>
        </div>
      )}

      {/* Post Snippet */}
      {item?.postSnippet && (
        <div className="mb-3 pl-0 md:pl-15">
          <div className="bg-muted rounded-lg p-3 border-l-4 border-primary">
            <p className="text-xs text-muted-foreground italic">"{item?.postSnippet}"</p>
          </div>
        </div>
      )}

      {/* Actions */}
      <div className="flex flex-wrap items-center gap-2 pl-0 md:pl-15">
        {item?.type === 'comment' || item?.type === 'mention' ? (
          <>
            <Button
              variant="outline"
              size="sm"
              iconName="Reply"
              onClick={() => setShowReply(!showReply)}
            >
              Reply
            </Button>
            <Button variant="ghost" size="sm" iconName="Heart">
              Like
            </Button>
          </>
        ) : (
          <Button variant="outline" size="sm" iconName="Eye">
            View Post
          </Button>
        )}
        <Button variant="ghost" size="sm" iconName="UserPlus">
          Connect
        </Button>
        <Button variant="ghost" size="sm" iconName="Calendar">
          Follow-up
        </Button>
      </div>

      {/* Reply Box */}
      {showReply && (
        <div className="mt-4 pl-0 md:pl-15 space-y-2">
          <textarea
            value={replyText}
            onChange={(e) => setReplyText(e?.target?.value)}
            placeholder="Write your response..."
            className="w-full p-3 rounded-lg border border-border bg-background text-foreground text-sm resize-none focus:outline-none focus:ring-2 focus:ring-primary"
            rows={3}
          />
          <div className="flex items-center gap-2">
            <Button size="sm" onClick={handleSendReply}>
              Send Reply
            </Button>
            <Button variant="ghost" size="sm" iconName="Sparkles">
              Use AI Suggestion
            </Button>
            <Button variant="ghost" size="sm" onClick={() => setShowReply(false)}>
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EngagementFeedItem;